import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=296cb8b6&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=296cb8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cb8b6",
  null
  
)

export default component.exports